import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
var RedirectToNewAppGuard = /** @class */ (function () {
    function RedirectToNewAppGuard() {
        this.userId = 0;
    }
    RedirectToNewAppGuard.prototype.canActivate = function (route, state) {
        var isNewVersion = localStorage.getItem('isNewVersion');
        var currentPath = state.url.startsWith('/') ? state.url : '/' + state.url;
        var allowedRoutes = [
            '/props',
            '/props-myteams/upcoming',
            '/props-myteams/live',
            '/props-myteams/history',
            '/rankings',
            '/lobby',
            '/news',
            '/user/refer-friend',
            '/messages',
            '/register/welcome',
            '/responsible',
            '/myteams'
        ];
        var isMessagesRoute = currentPath.startsWith('/messages');
        var isOwnershipRoute = currentPath.startsWith('/ownership');
        var isDraftRoute = currentPath.startsWith('/draft');
        var isDraftaAllowed = isDraftRoute && (isNewVersion == 'true');
        if (allowedRoutes.includes(currentPath) || isMessagesRoute || isOwnershipRoute || isDraftaAllowed) {
            var redirectUrl = "" + environment.NEW_SITE_URL + currentPath;
            window.location.href = redirectUrl;
            return false;
        }
        else {
            window.location.href = environment.SITE_URL + "/lobby";
        }
    };
    RedirectToNewAppGuard.ngInjectableDef = i0.defineInjectable({ factory: function RedirectToNewAppGuard_Factory() { return new RedirectToNewAppGuard(); }, token: RedirectToNewAppGuard, providedIn: "root" });
    return RedirectToNewAppGuard;
}());
export { RedirectToNewAppGuard };
